jQuery(function ($) {
	'use strict';

	var $link = $('a[href^=#]');
	var $body = $('body,html');
	var SPEED = 400;

	$link.on('click.pageScroll', function () {
		var href = $(this).attr('href');
		var target = $(href);

		if (href !== '#') {
			if (href === '#top') {
				target = $body;
			}

			var position = target.offset().top;

			$body.animate({
				scrollTop: position
			}, SPEED, 'swing');
			return false;
		}
	});


	var $topBtn = $('#js-page-to-top');
	$topBtn.hide();

	var timer;
	$(window).on('scroll', function () {
		clearTimeout(timer);
		timer = setTimeout(function () {
			if ($(this).scrollTop() < 100) {
				$topBtn.fadeOut();
			} else {
				$topBtn.fadeIn();
			}
		}, 100);
	});

});
